import { useState, type ReactNode } from 'react';
import { createPortal } from 'react-dom';
import { Link } from 'react-router-dom';
import { ENTITIES } from '../data';

interface TermProps {
  id: string;
  children?: ReactNode;
}

export function Term({ id, children }: TermProps) {
  const [pop, setPop] = useState<{ x: number; y: number } | null>(null);
  const entity = ENTITIES[id];
  if (!entity) return <span>{children}</span>;

  return (
    <>
      <Link
        className="rv-term"
        to={`/docs/concepts/${id}`}
        onMouseEnter={(ev) => {
          const rect = ev.currentTarget.getBoundingClientRect();
          setPop({ x: rect.left, y: rect.bottom + 6 });
        }}
        onMouseLeave={() => setPop(null)}
      >
        {children ?? entity.name}
      </Link>
      {pop &&
        createPortal(
          <div className="rv-term-pop" style={{ left: pop.x, top: pop.y }}>
            <div className="rv-term-pop-name">{entity.name}</div>
            <div className="rv-term-pop-text">{entity.oneLiner}</div>
          </div>,
          document.body,
        )}
    </>
  );
}
